import request from './service/index';
// scholarlist
export function getBannerList_Api(data){//查询列表
    return request({
        url:'CMS/settings/banner_list',
        method:'post',
        data:data
    });
}

export function getBanner_Api(id){//查询列表
    return request({
        url:`CMS/settings/banner_detail?banner_id=${id}`,
        method:'get',
    });
}

export function addBanner_Api(data){//查询列表
    return request({
        url:`CMS/settings/banner_detail`,
        method:'post',
        data:data
    });
}

export function updateBanner_Api(data){//查询列表
    return request({
        url:`CMS/settings/banner_detail`,
        method:'put',
        data:data
    });
}

export function deleteBanner_Api(data){//查询列表
    return request({
        url:`CMS/settings/banner_detail`,
        method:'delete',
        data:data
    });
}




// WEBPACK FOOTER //
// ./src/apis/settings.api.js